export { default, storeInfoPropTypes } from './StoreInfo';
